<div class="d-flex">
	<div class="ms-auto">
		<p-button *ngIf="!hideDelete" pRipple styleClass="p-button-raised p-button-danger m-2" [disabled]="deleteDisabled" (click)="deleteConfirmation()">
			<ng-template pTemplate="content">
				<div class="d-flex justify-content-center">
					<fa-icon [icon]="['far', 'trash']" size="lg" class="ms-1 me-2"></fa-icon>
					{{ deleteLabel }}
				</div>
			</ng-template>
		</p-button>
		<p-button *ngIf="!hideSave" pRipple styleClass="p-button-raised p-button-success m-2" [disabled]="saveDisabled" (click)="onSaveChange.emit(onSave)">
			<ng-template pTemplate="content">
				<div class="d-flex justify-content-center">
					<fa-icon [icon]="['far', 'save']" size="lg" class="ms-1 me-2"></fa-icon>
					{{ saveLabel }}
				</div>
			</ng-template>
		</p-button>

		<p-button
			*ngIf="!hideCancel"
			pRipple
			styleClass="p-button-raised p-button-secondary m-2"
			[disabled]="cancelDisabled"
			(click)="onCancelChange.emit(onCancel)"
		>
			<ng-template pTemplate="content">
				<div class="d-flex justify-content-center">
					<fa-icon [icon]="['far', 'times-circle']" size="lg" class="ms-1 me-2"></fa-icon>
					{{ cancelLabel }}
				</div>
			</ng-template>
		</p-button>

		<p-button *ngIf="!hideAdd" pRipple styleClass="p-button-raised p-button-primary m-2" [disabled]="addDisabled" (click)="onAddChange.emit(onAdd)">
			<ng-template pTemplate="content">
				<div class="d-flex justify-content-center">
					<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1 me-2"></fa-icon>
					{{ addLabel }}
				</div>
			</ng-template>
		</p-button>
	</div>
</div>
